import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 8px;
`

export const ActionIcons = styled.div`
  display: flex;
  gap: 8px;

  svg {
    width: 18px;
    height: 18px;
    cursor: pointer;
  }

  .download-icon {
    path {
      stroke: ${({ theme }) => theme.ds.colors.primary400};
    }
    &:hover {
      path {
        stroke: ${({ theme }) => theme.ds.colors.primary500};
      }
    }
  }
  .thresh-icon {
    path {
      fill: ${({ theme }) => theme.ds.colors.primary400};
    }
    &:hover {
      path {
        fill: ${({ theme }) => theme.ds.colors.primary500};
      }
    }
  }
`
export const DocumentDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;

  p {
    line-height: 1.3;
  }
`
